/// <amd-module name="Build/PipelinesLanguage/Services/SchemaService" />
import { JSONSchema, ParseSchema } from "AzurePipelinesLanguageService";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { TelemetryArea, TelemetryFeature } from "../Constants";

export class SchemaService {
    private _loadedSchemas: { [key: string]: Promise<JSONSchema> };
    private _pageContext: IVssPageContext;
    private _client: ITaskAgentRestClient;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._loadedSchemas = {};
        this._client = getTaskAgentClient(this._pageContext);
    }

    public getSchema = (location: string): Promise<JSONSchema> => {
        if (!this._loadedSchemas[location]) {
            this._loadedSchemas[location] = this._client.getYamlSchema().catch(e => {
                const service = this._pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
                service.publishEvent(TelemetryArea, TelemetryFeature, {
                    message: "Could not get YAML schema from service",
                    error: e
                });

                return this.loadSchema(location).then(ParseSchema);
            });
        }

        return this._loadedSchemas[location];
    };

    public useSchema = (location: string, schema: JSONSchema) => {
        this._loadedSchemas[location] = Promise.resolve(schema);
    };

    private loadSchema(location: string): Promise<string> {
        const url = getAssetLocation(this._pageContext, location);
        const promise = new Promise<string>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.onload = () => resolve(xhr.responseText);
            xhr.onerror = () => reject(xhr.statusText);
            xhr.open("GET", url, true);
            xhr.send();
        });
        return promise;
    }
}
